import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { EMPTY, Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { SessionService } from '@state/session/session.service';

@Injectable()
export class SessionInterceptor implements HttpInterceptor {
    // Flag para evitar múltiples logouts simultáneos
    private isLoggingOut = false;

    constructor(private sessionService: SessionService) {}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(
            catchError(err => {
                // Si ya estamos en proceso de logout, completar silenciosamente.
                // Solo llamadas AES (responseType text): silenciar errores de
                // assets/i18n o del mapper bloquearía el propio logout o el login
                if (this.isLoggingOut && req.responseType === 'text') {
                    return EMPTY;
                }

                return throwError(() => err);
            })
        );
    }

    /**
     * Llamado desde DataInterceptor cuando detecta ERROR_SESSION_EXPIRED.
     * Centraliza la lógica de "logout por sesión expirada" y
     * evita race conditions cuando múltiples peticiones fallan simultáneamente.
     */
    async handleSessionExpired(): Promise<void> {
        if (this.isLoggingOut) return;

        this.isLoggingOut = true;
        try {
            // El flag no puede depender de que systemLogout termine: si algo lo
            // bloquease, la app entera quedaría silenciando errores para siempre
            await Promise.race([
                this.sessionService.systemLogout(),
                new Promise<void>(resolve => setTimeout(resolve, 8000))
            ]);
        } finally {
            // Resetear flag después de un delay para evitar race conditions
            setTimeout(() => {
                this.isLoggingOut = false;
            }, 2000);
        }
    }
}
